import { css } from "styled-components";

export const breakpoints = {
  mobileL: 425,
  mobileXL: 512,
  tablet: 768,
  laptop: 1024,
  laptopL: 1440,
  desktopS: 2000,
  desktop: 2560,
};

export default Object.keys(breakpoints).reduce((acc, label) => {
  (acc as any)[label] = (...args: any) => css`
    @media (min-width: ${(breakpoints as any)[label]}px) {
      ${css.apply(null, args)};
    }
  `;
  return acc;
}, {});
